"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSTHOG_EVENT_NAMES = void 0;
exports.POSTHOG_EVENT_NAMES = {
    PAYWALL_SHOWN: 'paywall_shown',
};
